<div class="container bg-whitesmoke py-4">
  <app-breadcrumb [activePanel]="activeType"></app-breadcrumb>

  <div class="row">
    <div class="col-12">
      <mat-card class="shadow-sm rounded listing-container">
        <!-- Header with Tabs/Actions -->
        <mat-card-header class="listing-header">
          <div class="header-content">
            <mat-card-header class="listing-header">
              <div class="header-content">
                <div class="header-tabs">
                  <button class="tab-button active" (click)="openCreateForm()">
                    <mat-icon class="tab-icon">add_circle</mat-icon>
                    <span>Add {{ typeMeta[activeType].singular }}</span>
                  </button>
                  <button class="tab-button" *ngIf="activeType === 'product' || activeType === 'service'" (click)="generateListingContentViaAIChat()"
                    [disabled]="generatingFullContent">
                    <mat-icon class="tab-icon">auto_awesome</mat-icon>
                    <span>Create with AI Suggestions</span>
                  </button>
                    <div class="view-toggle-buttons">
                       <button mat-icon-button (click)="viewMode = 'grid'" [class.active]="viewMode === 'grid'">
    <mat-icon>view_module</mat-icon> <!-- Use 'view_module' instead of 'grid' -->
  </button>
  <button mat-icon-button (click)="viewMode = 'list'" [class.active]="viewMode === 'list'">
    <mat-icon>list</mat-icon>
  </button>
 
</div>
                </div>
              </div>
            </mat-card-header>

          </div>
        </mat-card-header>

        <mat-card-content class="listing-content">
          <div class="alert alert-danger rounded" *ngIf="!(loading$ | async) && (error$ | async) as err">
            {{ err }}
          </div>
          <!-- Products Grid -->
          <div class="products-grid" *ngIf="viewMode === 'grid'">
            <div class="product-card-wrapper" *ngFor="let item of activeItems$ | async">
              
              <div class="product-card" *ngIf="activeType !== 'reviews'">
                <!-- Product Header -->
                <div class="product-header">
                  <div class="product-title-section">
                    <h3 class="product-title">{{ getItemTitle(item) }}</h3>
                    
                    <div class="product-actions">
                      <button mat-icon-button class="action-btn edit-btn" (click)="openCreateForm(item)"
                        matTooltip="Edit">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button class="action-btn delete-btn" (click)="deleteItem(item.id)"
                        matTooltip="Delete">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div class="price-section">
                      <div class="price-display">
                        <ng-container *ngIf="item.discountPrice && item.discountPrice < item.price; else noDiscount">
                          <span class="original-price">{{ getItemPrice(item) | currency: item.currency }}</span>
                          <span class="current-price">{{ item.discountPrice | currency: item.currency }}</span>
                        </ng-container>
                        <ng-template #noDiscount>
                          <span class="current-price">{{ getItemPrice(item) | currency: item.currency }}</span>
                        </ng-template>
                      </div>
                    </div>
                </div>
                <!-- Description -->
                <div class="description-section" *ngIf="item.description">
                  <p class="product-description">
                    {{ isDescriptionExpanded(item.id) ? item.description : (item.description | slice:0:150) }}
                    <span *ngIf="item.description.length > 150 && !isDescriptionExpanded(item.id)">...</span>
                  </p>
                  <!-- <button *ngIf="item.description.length > 150" class="show-more-btn" (click)="toggleExpandDescription(item.id)">
  {{ isDescriptionExpanded(item.id) ? 'Show Less' : 'Show More' }}
</button> -->
                </div>
                <!-- Features List -->
                <div class="features-section" *ngIf="item.features && item.features.length > 0">
                  <ul class="features-list">
                    <li
                      *ngFor="let feature of isFeaturesExpanded(item.id) ? item.features : (item.features | slice:0:3)"
                      class="feature-item">
                      {{ feature }}
                    </li>
                  </ul>
                  <button *ngIf="item.features.length > 3" class="show-more-btn"
                    (click)="toggleExpandFeatures(item.id)">
                    {{ isFeaturesExpanded(item.id) ? 'Show Less' : '+' + (item.features.length - 3) + ' more' }}
                  </button>
                </div>
                <div class="product-footer">
                  <button class="btn-view-gallery" (click)="openImageGallery(item)">
                    <mat-icon>photo_library</mat-icon>
                    View Images
                  </button>
                  
                </div>
              </div>
           <div *ngIf="activeType === 'reviews'" class="review-card">
      <div class="review-header">
        <h4 class="review-title">{{ getReviewTitle(item) }}</h4>
        <div class="review-actions">
          <button mat-icon-button (click)="openCreateForm(item)" matTooltip="Edit">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteItem(item.id)" matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <p class="review-content">{{ getItemReview(item) }}</p>
      <p class="review-by">By: {{ item.name || item.reviewerName || 'Anonymous' }}</p>
    </div>
  </div>
</div>
<div class="list-view" *ngIf="viewMode === 'list'">
            <div class="list-item" *ngFor="let item of activeItems$ | async">
              <div class="list-item-content">
                <div class="list-item-header">
                  <h4>{{ getItemTitle(item) }}</h4>
                  <div class="list-item-price">
                    <span *ngIf="item.discountPrice && item.discountPrice < item.price" class="original-price">
                      {{ getItemPrice(item) | currency: item.currency }}
                    </span>
                    <span class="current-price">
                      {{ (item.discountPrice || getItemPrice(item)) | currency: item.currency }}
                    </span>
                  </div>
                </div>
                <p class="list-item-description" *ngIf="item.description">
                  {{ isDescriptionExpanded(item.id) ? item.description : (item.description | slice:0:150) }}
                  <span *ngIf="item.description.length > 150 && !isDescriptionExpanded(item.id)">...</span>
                  <!-- <button *ngIf="item.description.length > 150" class="show-more-btn">
                    {{ isDescriptionExpanded(item.id) ? 'Show Less' : 'Show More' }}
                  </button> -->
                </p>
                <div class="list-item-actions">
                  <button mat-icon-button (click)="openCreateForm(item)" matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button (click)="deleteItem(item.id)" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button mat-button (click)="openImageGallery(item)" *ngIf="getItemImages(item).length > 0">
                    <mat-icon>photo_library</mat-icon>
                    View Images
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Empty State -->
          <div *ngIf="(activeItems$ | async)?.length === 0" class="empty-state">
            <mat-icon class="empty-icon">inbox</mat-icon>
            <button mat-raised-button color="primary" (click)="openCreateForm()">
              <mat-icon>add</mat-icon>
              Create {{ typeMeta[activeType].singular }}
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<!-- Image Gallery Modal -->
<div *ngIf="showImageModal" class="image-modal-overlay" (click)="closeImageModal()">
  <div class="image-modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h5 class="modal-title">{{ selectedItemForModal ? getItemTitle(selectedItemForModal) : '' }} - Images</h5>
      <button class="btn btn-close" (click)="closeImageModal()"></button>
    </div>
    <div class="modal-body">
      <div class="image-viewer">
        <img [src]="modalImages[selectedImageIndex]" alt="Image" class="main-image">
        <button *ngIf="modalImages.length > 1" class="nav-btn prev-btn" (click)="previousImage()">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button *ngIf="modalImages.length > 1" class="nav-btn next-btn" (click)="nextImage()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <div class="image-counter">{{ selectedImageIndex + 1 }} of {{ modalImages.length }}</div>
      <div class="thumbnails" *ngIf="modalImages.length > 1">
        <div class="thumbnail-grid">
          <div *ngFor="let img of modalImages; let i = index" class="thumbnail"
            [class.active]="i === selectedImageIndex" (click)="selectImage(i)">
            <img [src]="img" alt="thumb">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeImageModal()">Close</button>
    </div>
  </div>
</div>

<!-- Create/Edit Form Modal -->


<!-- Suggestions Modal -->
<div *ngIf="showSuggestionsModal"
  class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
  style="background: rgba(0,0,0,0.8); z-index: 10002;" (click)="showSuggestionsModal = false">
  <div class="bg-white rounded shadow-lg position-relative"
    style="max-width: 700px; max-height: 80vh; overflow-y: auto;" (click)="$event.stopPropagation()">
    <div class="d-flex justify-content-between align-items-center p-4 border-bottom">
      <h5 class="mb-0 fw-bold">Choose a Suggestion</h5>
      <button class="btn btn-close" (click)="showSuggestionsModal = false"></button>
    </div>
    <div class="p-4">
      <p class="text-muted">Select a suggestion to auto-fill the form</p>
      <div class="list-group">
        <button *ngFor="let s of suggestions"
          class="list-group-item list-group-item-action d-flex flex-column align-items-start p-3 mb-2 border rounded shadow-sm"
          (click)="applySuggestion(s)">
          <div class="w-100 d-flex justify-content-between align-items-start">
            <strong class="text-primary">{{ s.name }}</strong>
            <span class="badge bg-success text-white ms-2">Recommended</span>
          </div>
          <p class="mt-2 text-secondary mb-0">{{ s.description }}</p>
        </button>
      </div>
      <div class="mt-4 text-center">
        <small class="text-muted">Or click outside to cancel</small>
      </div>
    </div>
    <div class="d-flex justify-content-end p-3 border-top bg-light">
      <button mat-button (click)="showSuggestionsModal = false">Cancel</button>
    </div>
  </div>
</div>